import styled from 'styled-components';

export const FooterContainer = styled.footer`
    padding: 30px 0;
    color: ${props => props.theme.footerTextColor};
    margin-top: auto;
    background: ${props => props.theme.footerBackgroundColor};

    .link {
        cursor: pointer;
        color: ${props => props.theme.footerTextColor};

        &:hover {
            text-decoration: underline;
        }
    }

    ul {
        margin: 0;
        padding: 0;
        list-style-type: none;

        li {
            margin: 0;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/footer/minimal/MinimalFooterComponentStyle.js